import { useQuery } from '@tanstack/react-query';
import { getIsQuestionnaireAttached } from '../../../../apis/questionnaires/requests';

export const useIsQuestionnaireAttached = (questionnaireId?: string | null) => {
  const { data: isAttached, isLoading } = useQuery({
    queryKey: ['isAttached', questionnaireId],
    queryFn: () => (questionnaireId ? getIsQuestionnaireAttached(questionnaireId) : Promise.resolve(false)),
    enabled: Boolean(questionnaireId)
  });

  return { isAttached, isLoading };
};
